/*
  Add here your own custom javascript codes
*/

// Function to preload images for a product card
function preloadVariantImages(productCard) {
  if (!productCard || productCard.dataset.imagesPreloaded === 'true') return;
  
  // Mark as preloaded to avoid duplicate work
  productCard.dataset.imagesPreloaded = 'true';
  
  // Get all variant images
  const variantImages = productCard.querySelectorAll('[data-variant-image] img');
  
  // Preload each image
  variantImages.forEach(img => {
    if (img.src) {
      const preloadLink = document.createElement('link');
      preloadLink.href = img.src;
      preloadLink.rel = 'preload';
      preloadLink.as = 'image';
      document.head.appendChild(preloadLink);
    }
  });
}

// Function to handle hover events
const hoverPreloadingCards = new WeakSet()

function setupHoverPreloading(scope = document) {
  const cards = [];
  if (scope.matches?.('[data-product-card]')) cards.push(scope);
  scope.querySelectorAll?.('[data-product-card]').forEach(card => cards.push(card));
  cards.forEach(card => {
    if (hoverPreloadingCards.has(card)) return;
    hoverPreloadingCards.add(card);

    // Preload on hover
    card.addEventListener('mouseenter', () => preloadVariantImages(card), { once: true });
    
    // Also preload on touch devices
    card.addEventListener('touchstart', () => preloadVariantImages(card), { once: true, passive: true });
  });
}

// Initialize variant selection using Shopify's built-in functionality
document.addEventListener('DOMContentLoaded', function() {
  // Set up hover preloading
  setupHoverPreloading();
  
  // Also set up for dynamically loaded content
  const hoverObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
      if (node.querySelectorAll) setupHoverPreloading(node);
      initializeVariantSelectors(node);
    }));
  });
  
  hoverObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Update SKU on variant change
  window.addEventListener('kt.product.variant.change', (event) => {
    const selectedVariant = event.detail;
    const sku = selectedVariant.sku;
    
    const skuElement = document.querySelector('.sku');
    if (skuElement) {
      skuElement.textContent = sku || 'N/A';
    }
  });
  // Helper: cache and return variant data for a given product card
  function getVariantData(productCard, variantId) {
    if (!productCard) return null;

    if (!productCard.__parsedVariants) {
      try {
        const rawVariants = productCard.getAttribute('data-variants');
        productCard.__parsedVariants = rawVariants ? JSON.parse(rawVariants) : [];
      } catch (error) {
        console.warn('Failed to parse variant data for product card', error);
        productCard.__parsedVariants = [];
      }
    }

    return productCard.__parsedVariants.find(function(variant) {
      return String(variant.id) === String(variantId);
    }) || null;
  }

  // Helper: normalize availability state for the currently selected option
  function determineVariantAvailability(productCard, selectedOption) {
    if (!selectedOption) return true;

    const availabilityAttr = selectedOption.dataset && typeof selectedOption.dataset.available !== 'undefined'
      ? String(selectedOption.dataset.available).toLowerCase().trim()
      : null;

    if (availabilityAttr === 'false') return false;
    if (availabilityAttr === 'true') return true;

    if (selectedOption.disabled) return false;

    const variantData = getVariantData(productCard, selectedOption.value);
    if (variantData && typeof variantData.available === 'boolean') {
      return Boolean(variantData.available);
    }

    return true;
  }

  function getSoldOutLabel(productCard) {
    if (productCard && productCard.dataset && productCard.dataset.soldOutLabel) {
      const label = productCard.dataset.soldOutLabel.trim();
      if (label) return label;
    }

    const themeSoldOut = window.theme
      && window.theme.locales
      && window.theme.locales.product
      && window.theme.locales.product.sold_out;

    if (typeof themeSoldOut === 'string' && themeSoldOut.trim()) {
      return themeSoldOut.trim();
    }

    return 'Sold out';
  }

  function syncVariantButtons(productCard, selectedVariantId) {
    if (!productCard) return;

    var buttons = productCard.querySelectorAll('.product-card-variant-option');
    if (!buttons.length) return;

    buttons.forEach(function(button) {
      var buttonVariantId = button.dataset.variantId;
      var isMatch = String(buttonVariantId) === String(selectedVariantId);
      var isAvailable = button.dataset.available !== 'false';

      button.classList.toggle('is-active', isMatch);
      button.classList.toggle('is-unavailable', !isAvailable);
      button.setAttribute('aria-pressed', isMatch ? 'true' : 'false');

      button.removeAttribute('aria-disabled');

      if (button.disabled) {
        button.disabled = false;
      }
    });
  }

  function updateVariantLabel(productCard, labelText) {
    if (!productCard) return;
    var labelTarget = productCard.querySelector('[data-variant-label-text]');
    if (!labelTarget) return;

    // Hide the text if it contains "Figurine", but show all other variants
    if (labelText && labelText.toLowerCase().includes('figurine')) {
      labelTarget.textContent = labelText || '';
      labelTarget.style.display = 'none';
    } else {
      labelTarget.textContent = labelText || '';
      labelTarget.style.display = '';
    }
  }

  function getNotifyUrl(baseProductUrl, selectedVariantId) {
    const destination = new URL(baseProductUrl, window.location.origin);
    destination.searchParams.set('variant', selectedVariantId);
    destination.hash = 'bis-wrapper';
    return destination.origin === window.location.origin
      ? destination.pathname + destination.search + destination.hash
      : destination.href;
  }

  // Helper: sync sold-out styling, badge, and ATC button state
  function syncSoldOutState(productCard, isAvailable, selectedVariantId) {
    if (!productCard) return;

    productCard.dataset.variantAvailability = isAvailable ? 'available' : 'sold-out';

    const soldOutLabel = getSoldOutLabel(productCard);
    const notifyLabel = (function() {
      const notifyText = productCard.querySelector('.btn-atc')?.dataset?.notifyText;
      if (notifyText && notifyText.trim()) {
        return notifyText.trim();
      }
      const localeNotify = window.theme
        && window.theme.locales
        && window.theme.locales.product
        && window.theme.locales.product.notify_me;
      if (typeof localeNotify === 'string' && localeNotify.trim()) {
        return localeNotify.trim();
      }
      return 'Notify me';
    })();

    const atcButton = productCard.querySelector('.btn-atc');
    if (atcButton) {
      if (!atcButton.dataset.availableText) {
        atcButton.dataset.availableText = atcButton.textContent.trim();
      }
      if (!atcButton.dataset.notifyText) {
        atcButton.dataset.notifyText = notifyLabel;
      }

      atcButton.style.transform = '';
      atcButton.style.boxShadow = '';

      if (isAvailable) {
        atcButton.type = 'submit';
        atcButton.dataset.state = 'add';
        atcButton.disabled = false;
        atcButton.classList.remove('btn-atc--disabled', 'btn-atc--notify');
        atcButton.removeAttribute('aria-disabled');
        atcButton.style.pointerEvents = '';
        atcButton.style.cursor = '';
        atcButton.removeAttribute('title');
        if (atcButton.dataset.availableText) {
          atcButton.textContent = atcButton.dataset.availableText;
        }
      } else {
        atcButton.type = 'button';
        atcButton.dataset.state = 'notify';
        atcButton.disabled = false;
        atcButton.classList.add('btn-atc--notify');
        atcButton.removeAttribute('aria-disabled');
        atcButton.style.pointerEvents = '';
        atcButton.style.cursor = '';
        atcButton.setAttribute('title', soldOutLabel);
        atcButton.textContent = notifyLabel;
      }
    }

    const optionsCta = productCard.querySelector('[data-product-card-options-cta]');
    if (optionsCta) {
      if (!optionsCta.dataset.availableText) {
        optionsCta.dataset.availableText = optionsCta.textContent.trim();
      }
      if (!optionsCta.dataset.notifyText) {
        optionsCta.dataset.notifyText = notifyLabel;
      }

      const baseProductUrl = optionsCta.dataset.baseProductUrl || productCard.dataset.productUrl || optionsCta.getAttribute('href') || '';
      const optionsLabel = optionsCta.querySelector('[data-product-card-options-label]');
      if (isAvailable) {
        optionsCta.dataset.state = 'choose-options';
        if (optionsLabel) optionsLabel.textContent = optionsCta.dataset.availableText;
        else optionsCta.textContent = optionsCta.dataset.availableText;
        optionsCta.href = baseProductUrl;
        optionsCta.removeAttribute('title');
      } else {
        optionsCta.dataset.state = 'notify';
        if (optionsLabel) optionsLabel.textContent = optionsCta.dataset.notifyText;
        else optionsCta.textContent = optionsCta.dataset.notifyText;
        optionsCta.href = getNotifyUrl(baseProductUrl, selectedVariantId);
        optionsCta.setAttribute('title', soldOutLabel);
      }
    }

    const variantInput = productCard.querySelector('.product-card-form-variant-input');
    if (variantInput) {
      variantInput.removeAttribute('disabled');
    }

    const imgWrapper = productCard.querySelector('.product-card-img-wrapper');
    if (imgWrapper) {
      const dynamicBadgeSelector = '.product-sold-out-badge[data-dynamic-badge="true"]';
      let dynamicBadge = imgWrapper.querySelector(dynamicBadgeSelector);
      const staticBadge = imgWrapper.querySelector('.product-sold-out-badge:not([data-dynamic-badge])');

      if (!isAvailable) {
        if (!dynamicBadge && !staticBadge) {
          dynamicBadge = document.createElement('span');
          dynamicBadge.className = 'product-sold-out-badge badge';
          dynamicBadge.dataset.dynamicBadge = 'true';
          dynamicBadge.textContent = ` 😢 ${soldOutLabel} 😢 `;
          imgWrapper.appendChild(dynamicBadge);
        } else if (dynamicBadge) {
          dynamicBadge.textContent = ` 😢 ${soldOutLabel} 😢 `;
          dynamicBadge.classList.remove('d-none');
          dynamicBadge.removeAttribute('hidden');
        } else if (staticBadge) {
          staticBadge.classList.remove('d-none');
          staticBadge.removeAttribute('hidden');
        }
      } else if (dynamicBadge) {
        dynamicBadge.remove();
      }
    }

    productCard.classList.toggle('product-card--variant-sold-out', !isAvailable);
  }

  // Function to update variant state
  function updateVariantState(select) {
    var productCard = select.closest('[data-product-card]');
    if (!productCard) return;

    var selectedVariantId = select.value;
    var selectedOption = select.options[select.selectedIndex];
    if (!selectedOption || !selectedVariantId) return;

    var isVariantAvailable = determineVariantAvailability(productCard, selectedOption);

    // Update the hidden input value
    var hiddenInput = productCard.querySelector('input[name="id"][type="hidden"]');
    if (hiddenInput) {
      hiddenInput.value = selectedVariantId;
      hiddenInput.dataset.variantId = selectedVariantId;
    }

    var priceContainer = productCard.querySelector('[data-product-price]');
    if (priceContainer && selectedOption.dataset.price) {
      var price = selectedOption.dataset.price;
      var comparePrice = selectedOption.dataset.comparePrice || '';
      var priceCents = parseInt(selectedOption.dataset.priceCents || '', 10);
      var compareCents = parseInt(selectedOption.dataset.comparePriceCents || '', 10);
      
      // Update price display
      var priceHtml;
      // Get currency from cart object or default to store currency
      var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
        ? window.Shopify.currency.active
        : (document.querySelector('.price-currency') ? document.querySelector('.price-currency').textContent.trim() : 'AUD');

      if (compareCents > priceCents && comparePrice) {
        priceHtml = '<s class="product-card-price-compare text-muted ms-2">' +
          '<span class="visually-hidden">Regular price</span>' +
          comparePrice +
          '</s>' +
          '<span class="product-card-price-final product-price-final-sale">' +
          '<span class="visually-hidden">Sale price</span>' +
          price + '&nbsp;<span class="price-currency">' + currency + '</span>' +
          '</span>';
      } else {
        priceHtml = '<span class="product-card-price-final">' +
          price + '&nbsp;<span class="price-currency">' + currency + '</span>' +
          '</span>';
      }

      priceContainer.innerHTML = '<p class="product-card-price product-price mb-4">' + priceHtml + '</p>';
    }
    
    var defaultImage = productCard.querySelector('[data-default-image]');
    var variantImages = productCard.querySelectorAll('[data-variant-image]');

    function initImage(img) {
      if (!img) return;
      img.style.transition = 'opacity 0.3s ease';
      img.style.opacity = '0';
      img.style.display = 'none';
      img.classList.add('d-none');
    }

    if (defaultImage) initImage(defaultImage);
    variantImages.forEach(initImage);

    function showImage(img) {
      if (!img) return;
      img.style.display = 'block';
      img.classList.remove('d-none');
      void img.offsetWidth;
      img.style.opacity = '1';
    }

    var found = false;
    variantImages.forEach(function(img) {
      if (parseInt(img.dataset.variantId) === parseInt(selectedVariantId)) {
        showImage(img);
        found = true;
      }
    });

    if (!found && defaultImage) {
      showImage(defaultImage);
    }

    var variantButton = productCard.querySelector('.product-card-variant-option[data-variant-id="' + selectedVariantId + '"]');
    var variantData = getVariantData(productCard, selectedVariantId);
    var variantLabelText = '';

    if (variantButton && variantButton.dataset.variantLabel) {
      variantLabelText = variantButton.dataset.variantLabel;
    } else if (variantData && variantData.title) {
      variantLabelText = variantData.title;
    } else if (selectedOption && selectedOption.textContent) {
      variantLabelText = selectedOption.textContent.replace(/\s*-\s*Sold Out$/i, '').trim();
    }

    if (productCard.hasAttribute('data-product-card-variant-navigation')) {
      const destination = new URL(productCard.dataset.productUrl, window.location.origin);
      destination.searchParams.set('variant', selectedVariantId);
      const variantUrl = destination.pathname + destination.search + destination.hash;
      productCard.querySelectorAll('[data-product-card-navigation]').forEach(link => {
        link.href = variantUrl;
        if (link.hasAttribute('data-product-card-options-cta')) link.dataset.baseProductUrl = variantUrl;
      });
    }

    syncSoldOutState(productCard, isVariantAvailable, selectedVariantId);
    syncVariantButtons(productCard, selectedVariantId);
    updateVariantLabel(productCard, variantLabelText);
  }

  function initializeVariantSelectors(scope) {
    if (scope.matches?.('.variant-selector')) updateVariantState(scope);
    scope.querySelectorAll?.('.variant-selector').forEach(updateVariantState);
  }

  initializeVariantSelectors(document);
  
  // Sync variant selectors within the same product card
  function syncVariantSelectors(changedSelect) {
    var productCard = changedSelect.closest('[data-product-card]');
    if (!productCard) return;
    
    var allSelectors = productCard.querySelectorAll('.variant-selector');
    var selectedValue = changedSelect.value;
    
    allSelectors.forEach(function(selector) {
      if (selector !== changedSelect) {
        selector.value = selectedValue;
      }
    });
  }

  // Enhanced variant selector change handler
  document.addEventListener('change', function(event) {
    if (event.target.classList.contains('variant-selector')) {
      updateVariantState(event.target);
      syncVariantSelectors(event.target);
    }
  });

  // Variant option buttons: handle selection & notify CTA redirect
  document.addEventListener('click', function(event) {
    var notifyButton = event.target.closest('[data-product-card] .btn-atc');
    if (notifyButton) {
      var productCardForNotify = notifyButton.closest('[data-product-card]');
      if (productCardForNotify && notifyButton.dataset.state === 'notify') {
        event.preventDefault();
        event.stopPropagation();

        var productUrl = productCardForNotify.dataset.productUrl || '';
        var variantInput = productCardForNotify.querySelector('.product-card-form-variant-input');
        var variantIdValue = variantInput ? variantInput.value : '';

        if (productUrl) {
          try {
            var destination = new URL(productUrl, window.location.origin);
            if (variantIdValue) {
              destination.searchParams.set('variant', variantIdValue);
            }
            destination.hash = 'bis-wrapper';
            window.location.href = destination.href;
            return;
          } catch {
            var fallbackUrl = productUrl;
            if (variantIdValue) {
              fallbackUrl += (fallbackUrl.indexOf('?') !== -1 ? '&' : '?') + 'variant=' + encodeURIComponent(variantIdValue);
            }
            if (fallbackUrl.indexOf('#') === -1) {
              fallbackUrl += '#bis-wrapper';
            }
            window.location.href = fallbackUrl;
            return;
          }
        }
      }
    }

    var optionButton = event.target.closest('.product-card-variant-option');
    if (optionButton) {
      event.preventDefault();
      event.stopPropagation();

      var productCard = optionButton.closest('[data-product-card]');
      if (!productCard) return;

      var select = productCard.querySelector('.variant-selector');
      if (!select) return;

      var variantId = optionButton.dataset.variantId;
      var matched = false;

      Array.from(select.options).forEach(function(option) {
        if (String(option.value) === String(variantId)) {
          option.selected = true;
          matched = true;
        } else {
          option.selected = false;
        }
      });

      if (matched) {
        updateVariantState(select);
      }

      return;
    }

    if (event.target.classList.contains('variant-selector') || 
        event.target.closest('.product-card-variant-selector')) {
      event.stopPropagation();
      event.preventDefault();
    }
  });

  // Also prevent mousedown to be extra safe
  document.addEventListener('mousedown', function(event) {
    if (event.target.classList.contains('variant-selector') || 
        event.target.closest('.product-card-variant-selector')) {
      event.stopPropagation();
    }
  });
});
